import React from 'react'
import PropTypes from 'prop-types'
import ArrowDownIcon from '../../ui/icons/ArrowDownIcon'

const BASE_CLASSES = 'tw:flex tw:items-center tw:pr-2 tw:text-[#4b5563]'

const StatusSelectIndicator = ({ innerProps, selectProps }) => (
  <span {...innerProps} className={BASE_CLASSES}>
    <ArrowDownIcon className={`tw:size-4.5 ${selectProps.menuIsOpen ? 'tw:rotate-180' : ''}`} />
  </span>
)

StatusSelectIndicator.propTypes = {
  innerProps: PropTypes.shape({
    onMouseDown: PropTypes.func,
    onTouchEnd: PropTypes.func
  }),
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool
  }).isRequired
}

StatusSelectIndicator.defaultProps = {
  innerProps: null
}

export default StatusSelectIndicator
